// @flow

import React from 'react';

export type IntroType = {
  imgSrc: string,
  description: string,
};

const IntroSection = ({ intro }: { intro: IntroType }) => (
  <div className="intro-section-container pad-top-2 pad-bottom-2">
    <img className="icon-left" src={intro.imgSrc} alt="icon" />
    <div className="content">{intro.description}</div>
  </div>
);

export default IntroSection;
